module.exports = __webpack_public_path__ + "img/liquor_bin_list.f9ae21cb.png";